import MuiTabs from '@material-ui/core/Tabs';
import { withStyles } from '@material-ui/core/styles';
// Empty styles are just to help with console errors due to prop validation
const Tabs = withStyles(theme => ({
  root: {},
  vertical: {},
  flexContainer: {},
  flexContainerVertical: {},
  centered: {},
  scroller: {},
  fixed: {},
  scrollable: {},
  scrollButtons: {},
  scrollButtonsDesktop: {},
  indicator: {
    height: theme.spacing(0.5),
    backgroundColor: theme.palette.facet.accentBlue,
  },
}))(MuiTabs);
export default Tabs;
